import axiosInstance from '../../../config/axiosInstance';
import { PurchaseOrderValidation } from "../View/Validations/PurchaseOrderValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
 
  event.preventDefault();
  const formErrors = PurchaseOrderValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.formData.ClientID=CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.formData.UserID=UserID;
      const response = await axiosInstance.post(`/PurchaseOrder/CreatePurchaseOrder`, formData);
      localStorage.setItem('PurchaseOrderID', response.data.PurchaseOrderID);
      return response.data.message;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };